module.exports = __webpack_public_path__ + "img/bg-dark.4b01c593.jpg";